import { Message } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from './createMakeCall';

interface ConversationMessages {
  messages: Message[];
  count: number;
}

export default (makeCall: MakeCall) => (conversationId: number) =>
  makeCall<ConversationMessages>(
    'GET',
    `/api/v2/conversation/${conversationId}/messages`,
  );
